import BigNumber from 'bignumber.js';

import PairsManagerFacet from '../../abis/PairsManagerFacet';
import { ExtractReturn } from '../../types/ExtractFunctionReturn';

export type ContractPairsV4 = Readonly<
  ExtractReturn<typeof PairsManagerFacet, 'pairsV4'>[0]
>;

export type LeverageMargin = Omit<
  ContractPairsV4['leverageMargins'][number],
  'notionalUsd'
> & {
  notionalUsdBuffered: BigNumber;
};

export type PairsV4 = Omit<
  ContractPairsV4,
  | 'fundingFeePerSecondP'
  | 'feeConfig'
  | 'maxFundingFeeR'
  | 'maxLongOiUsd'
  | 'maxShortOiUsd'
  | 'minFundingFeeR'
  | 'leverageMargins'
  | 'longHoldingFeeRate'
  | 'shortHoldingFeeRate'
  | 'slippageConfig'
> & {
  fundingFeePerSecondP: BigNumber;
  feeConfig: Omit<
    ContractPairsV4['feeConfig'],
    'openFeeP' | 'closeFeeP' | 'shareP' | 'minCloseFeeP' | 'lvTokenDiscountP'
  > & {
    // normalize to use decimals
    openFeeP: number;
    closeFeeP: number;
    shareP: number;
    minCloseFeeP: number;
    lvTokenDiscountP: number;
  };
  leverageMargins: LeverageMargin[];
  maxFundingFeeR: BigNumber;
  maxLongOiUsdBuffered: BigNumber;
  maxShortOiUsdBuffered: BigNumber;
  minFundingFeeR: BigNumber;
  longHoldingFeeRate: BigNumber;
  shortHoldingFeeRate: BigNumber;
  slippageConfig: {
    enable: boolean;
    index: number;
    longThresholdUsd: BigNumber;
    name: string;
    onePercentDepthAboveUsd: BigNumber;
    onePercentDepthBelowUsd: BigNumber;
    shortThresholdUsd: BigNumber;
    slippageLongP: number;
    slippageShortP: number;
    slippageType: SlippageType;
  };
};

export enum SlippageType {
  FIXED,
  ONE_PERCENT_DEPTH,
  // NET_POSITION
}
